<!--suppress ALL -->
<template>
  <div class="notification-upload-item animated fadeIn">
    <div class="loadupload" :style="`width: ${uploader.percentage}%`"></div>
    <!--<a class="button close is-small"><i class="ion ion-android-close"></i></a>-->
    <div class="notification-upload-item-inner">
      <lazy-img lazy-src="/static/images/file-upload.png"
                class="notif-bg-upload" :lazy="true"/>
      <div class="detail">
        <p v-if="uploader.message" class="title is-6">{{ uploader.message }}</p>
        <p class="text-mute">{{ date }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop} from 'annotation';

@Component
export default class UploadProgress extends Vue {

  @Prop({default: {percentage: 0, message: "Uploading ....."}})
  public uploader: any;

  public date: string = new Date().toDateString();
}
</script>

<style lang="scss" scoped>
@import "../../style/variables_function";

.notification-upload-item {
  background: $grey-lighten;
  position: relative;
  border-radius: 5px;

  &:not(:last-child) {
    border-bottom: 1px solid $grey-lighter;
  }

  .loadupload {
    @include fill_fixed_absolute;
    top: 0;
    left: 0;
    background-color: lighten($green, 30%);
  }

  .notification-upload-item-inner {
    position: relative;
    padding: .5rem .75rem;
    @include fl_row;
    align-items: center;

    .notif-bg-upload {
      width: 30px;
      height: 30px;
      margin-right: 1rem;
    }

    .detail {
      flex: 1;

      p.title {
        margin-bottom: .5rem;
      }
    }
  }
}
</style>
